import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h3>
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/understanding-the-api.md"
      }}>{`Understanding the API`}</a></p>
    <p>{`Get an understanding of how the Cloud Manager API is structured.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/create-api-integration.md"
      }}>{`Creating an API Integration`}</a></p>
    <p>{`Learn how to create an API Integration Project.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/create-event-integration.md"
      }}>{`Creating an Event Integration`}</a></p>
    <p>{`Learn how to create an Event Integration Project to receive webhooks when your pipelines execute.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/getting-started-with-postman.md"
      }}>{`Getting Started with Postman`}</a></p>
    <p>{`Learn how to experiment with the API using Postman.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/authentication/authentication.md"
      }}>{`Authentication`}</a></p>
    <p>{`Learn how to authenticate API calls.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/authentication/jwt-authentication.md"
      }}>{`JWT Authentication (Deprecated)`}</a></p>
    <p>{`Learn how to authenticate API calls using JWT.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/getting-started/permissions.md"
      }}>{`Permissions`}</a></p>
    <p>{`See which permissions are required for using the API.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      